// 站点logo图片
import logoImage from '@/images/logo.png';
import logoTextImage from '@/images/logo-text.png';

// 文件CDN地址
export const fileServerBaseUrl = 'https://shuijl-fileservers.oss-cn-hangzhou.aliyuncs.com';

// 站点信息配置
export const siteMap = {
  logo: logoImage,
  logoText: logoTextImage,
  title: '水精灵五金管理系统',
  hotline: '13867597115',
};

// 系统参数
export const sysParam = {
  token: 'BS-ADMIN-TOKEN',
};

// 常用图片url
export const commonUrl = {
  noGoodsIcon: logoImage,
};

// 短信模板发送状态
export const msgPushState = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '发送成功',
    value: 1,
  },
  {
    name: '发送失败',
    value: 0,
  },
];

// 短信渠道
export const noteDitchList = [
  {
    value: 1,
    label: '验证码渠道',
  },
  {
    value: 2,
    label: '营销渠道',
  },
];

// 用户身份枚举列表
export const companyTypeArr = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '批发客户',
    value: 1,
  },
  {
    label: '零散客户',
    value: 2,
  },
  // {
  //   label: '经销商',
  //   value: 3,
  // },
  // {
  //   label: '合作伙伴',
  //   value: 4,
  // },
  {
    label: '普通用户',
    value: 5,
  },
];

// 注册渠道枚举列表
export const registerSourceArr = [
  {
    label: 'xcx',
    value: 'XCX',
  },
  // {
  //   label: 'web',
  //   value: 'WEB',
  // },
];

// 审核状态枚举列表
export const auditStatusArr = [
  {
    label: '待审核',
    value: 1,
  },
  {
    label: '已通过',
    value: 2,
  },
  {
    label: '审核拒绝',
    value: 3,
  },
];

// 有效期枚举列表
export const validUntilArr = [
  {
    label: '有效',
    value: 1,
  },
  {
    label: '已过期',
    value: 2,
  },
];

// 交易渠道
export const channelList = [
  // {
  //   label: 'web',
  //   value: 'web',
  // },
  {
    label: 'xcx',
    value: 'xcx',
  },
];

// banner跳转类型
export const jumpTypeList = [
  {
    label: '不跳转',
    value: 1,
  },
  {
    label: '商品详情',
    value: 2,
  },
  {
    label: 'web网页',
    value: 3,
  },
  {
    label: '商品搜索页',
    value: 4,
  },
];

// banner展示位置
export const showLocations = [
  {
    label: '首页',
    value: 1,
  },
];

// 用户反馈状态
export const feedbackStatus = [
  {
    label: '待审核',
    value: 1,
  },
  {
    label: '有效',
    value: 2,
  },
  {
    label: '无效',
    value: 3,
  },
];
